import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.6 14.6C18.4 14 19 13 19 12s-.6-2-1.4-2.6m3.2 8.2c1.4-1.4 2.2-3.4 2.2-5.6 0-2.2-1-4.2-2.4-5.8M6 15l5.2 5.2c.6.6 1.8.2 1.8-.6V4.4c0-.8-1-1.4-1.8-.6L6 9H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4Z",
  stroke: "currentColor",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }